export default __webpack_public_path__ + "09a24bafecbeeb746dbb40c64487679c.jpg";